export const DRAWERWIDTH = { sm: 240, md: 264, xl: 320 };
export const MIN_WIDTH_VISIBLE = 769;